"use strict";

var accordionHeaders = document.querySelectorAll(".accordion-header");
accordionHeaders.forEach(function (header) {
  header.addEventListener("click", function () {
    var body = header.nextElementSibling;
    var icon = header.querySelector("i");
    var isOpen = !body.classList.contains("max-h-0");
    if (isOpen) {
      body.style.maxHeight = 0;
    } else {
      body.style.maxHeight = body.scrollHeight + "px";
    }
    body.classList.toggle("max-h-0");
    icon.classList.toggle("fa-chevron-down");
    icon.classList.toggle("fa-chevron-up");
  });
});
//# sourceMappingURL=accordion.js.map